import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { alertActions } from "../../../actions/alert.actions";
import { StandardService } from "../../../services";
import { commaValidation } from "../../../utility";
import { BookingDetailsService } from "../../../services";
import { produce } from "immer";
import { MyAccountService } from "../../../services";

const useStandard = (location, t) => {
  const [mobile_no, setMobile_no] = useState("");
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [startEndDate, setStartEndDate] = useState("");
  const [startEndDateRange, setStartEndDateRange] = useState("");
  // console.log("Href Link", window.location.href);
  const [adult, setAdult] = useState(
    localStorage.getItem("adult") ? Number(localStorage.getItem("adult")) : 0
  );
  //   const {

  // } = useBookingDetails( locations);
  const [singleOccupancyCharge, setSigleOccupancyCharge] = useState(0);
  const dispatch = useDispatch();
  const [children, setChildren] = useState(
    localStorage.getItem("children")
      ? Number(localStorage.getItem("children"))
      : 0
  );
  const [tableCalculation, setTableCalucation] = useState(0);
  const [totalRoomCharge, setTotalRoomCharge] = useState(0);
  const [totalGstCharge, setTotalGstCharge] = useState(0);
  const [totalPayableAmount, setTotalPayableAmount] = useState(0);
  const [rooms, setRooms] = useState(
    localStorage.getItem("rooms") ? Number(localStorage.getItem("rooms")) : 1
  );
  const [roomData, setRoomData] = useState("");
  const [roomAdded, setRoomAdded] = useState("NO");
  let [roomAmount, setRoomAmount] = useState("");
  const urlParams = new URLSearchParams(window.location.search);
  const room_id = urlParams.get("id");
  let calculatedTotal = 0;
  let calculatedGstCharge = 0;
  // let totalPayableAmount = 0;
  const user_id = useSelector((state) => state?.userData?.user?._id);
  const [showShipping, setShowShipping] = useState(false);
  const [pathimg, setPathimg] = useState();
  const [singleOccCharge, setSingleOccCharge] = useState(0);
  const [extraOccCharge, setExtraOccCharge] = useState(0);
  const [bookingId, setBookingId] = useState([]);
  const [formattedArrivalDate, setFormattedArrivalDate] = useState("");
  const [formattedDepartureDate, setFormattedDepartureDate] = useState("");
  const [datetimevalue, setdatetimevalue] = useState(
    localStorage.getItem("datetime1")
      ? localStorage
        .getItem("datetime1")
        .replace(
          "00:00:00 GMT+0530" ||
          "01:00:00 GMT+0530" ||
          "02:00:00 GMT+0530" ||
          "03:00:00 GMT+0530" ||
          "04:00:00 GMT+0530" ||
          "05:00:00 GMT+0530" ||
          "06:00:00 GMT+0530" ||
          "07:00:00 GMT+0530" ||
          "08:00:00 GMT+0530" ||
          "09:00:00 GMT+0530" ||
          "10:00:00 GMT+0530" ||
          "11:00:00 GMT+0530" ||
          "12:00:00 GMT+0530" ||
          "13:00:00 GMT+0530" ||
          "14:00:00 GMT+0530" ||
          "15:00:00 GMT+0530" ||
          "16:00:00 GMT+0530" ||
          "17:00:00 GMT+0530" ||
          "18:00:00 GMT+0530" ||
          "19:00:00 GMT+0530" ||
          "20:00:00 GMT+0530" ||
          "21:00:00 GMT+0530" ||
          "22:00:00 GMT+0530" ||
          "23:00:00 GMT+0530" ||
          "24:00:00 GMT+0530",
          "14:00:00 GMT+0530"
        )
      : ""
  );
  const [datetimevalue1, setdatetimevalue1] = useState(() => {
    const storedDate = localStorage.getItem("datetime2");
    return storedDate ? formatDate(storedDate) : "";
  });
  // const [datetimevalue1, setdatetimevalue1] = useState(
  //   localStorage.getItem("datetime2")
  //     ? localStorage
  //         .getItem("datetime2")
  //         .replace(
  //           "00:00:00 GMT+0530" ||
  //             "01:00:00 GMT+0530" ||
  //             "02:00:00 GMT+0530" ||
  //             "03:00:00 GMT+0530" ||
  //             "04:00:00 GMT+0530" ||
  //             "05:00:00 GMT+0530" ||
  //             "06:00:00 GMT+0530" ||
  //             "07:00:00 GMT+0530" ||
  //             "08:00:00 GMT+0530" ||
  //             "09:00:00 GMT+0530" ||
  //             "10:00:00 GMT+0530" ||
  //             "11:00:00 GMT+0530" ||
  //             "12:00:00 GMT+0530" ||
  //             "13:00:00 GMT+0530" ||
  //             "14:00:00 GMT+0530" ||
  //             "15:00:00 GMT+0530" ||
  //             "16:00:00 GMT+0530" ||
  //             "17:00:00 GMT+0530" ||
  //             "18:00:00 GMT+0530" ||
  //             "19:00:00 GMT+0530" ||
  //             "20:00:00 GMT+0530" ||
  //             "21:00:00 GMT+0530" ||
  //             "22:00:00 GMT+0530" ||
  //             "23:00:00 GMT+0530" ||
  //             "24:00:00 GMT+0530",
  //           "12:00:00 GMT+0530"
  //         )
  //     : ""
  // );
  const [checkindate, setCheckindate] = useState();
  const [checkoutdate, setCheckoutdate] = useState();
  const [checkintime, setCheckintime] = useState("");
  const [checkouttime, setCheckouttime] = useState("");
  const phone = useSelector((state) => state?.userData?.user?.phone);
  const name = useSelector((state) => state?.userData?.user?.name);
  const navigate = useNavigate();
  const [service, setService] = useState([]);
  const [extra, setExtra] = useState(0);
  const [diffDate, setDiffDate] = useState(0);
  const [amountData, setAmountData] = useState([]);
  const [amountData1, setAmountData1] = useState([]);
  const [addAmount, setAddAmount] = useState("");
  const [addAmount1, setAddAmount1] = useState("");
  const [loader, setLoader] = useState("notset");
  const [timediff, setTimediff] = useState();
  const [showPopup, setShowPopup] = useState(false);
  var timedifferences;
  var updatedList = [];
  var updatedList1 = [];
  var dataPath;
  var updatedService = [];
  var updatedService1 = [];
  var servicearray = [];
  var mydata = [];
  const [servId, setServiceId] = useState([]);
  const [upService, setUpService] = useState([]);
  const [upService1, setUpService1] = useState([]);
  const [adultcount, setAdultcount] = useState([]);
  const [totservice, setTotalService] = useState([]);
  var adults = 0;
  const [datafinalvalue, setdatafinalvalue] = useState(0);
  const [datafinaltax, setdatafinaltax] = useState(0);
  const [displaycount, setdisplaycount] = useState(true);
  const [actamount, setactamount] = useState(0);
  const [singleOccupied, setsingleOccupied] = useState([]);
  const [extraOccupied, setExtraOccupied] = useState([]);
  const [singleRoomInfo, setSingleRoomInfo] = useState([]);
  var checkInDate = checkindate;
  //commented by sumanth
  // const [childrenCount, setChildrenCount] = useState();
  const [childrenCount, setChildrenCount] = useState({});
  const AdultCountLoc = localStorage.getItem("AdultCount");
  const ChildrenAgesLoc = localStorage.getItem("ChildrenAges");
  const ChildrenCountLoc = localStorage.getItem("ChildrenCount");
  const [initialLoad, setInitialLoad] = useState(true);
  const [request, setRequest] = useState("");


  var update = [];
  var extradata = 0;
  var total_pay_amount = 0;
  var countlength = 0;
  var taxdata = 0;
  var singletax = 0;
  var skiptax = 0;
  var totTax = 0;
  var actualamount = 0;
  var skipdayamount = 0;

  function formatDate(datetime) {
    if (!datetime) return "";
    const date = new Date(datetime);
    date.setHours(12, 0, 0, 0);
    const formattedDate = date.toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });
    const formattedTime = "12:00 PM";
    return `${formattedDate} ${formattedTime}`;
  }

  function formatDateRangessss(startDate, endDate) {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const monthYearFormatter = new Intl.DateTimeFormat("en-US", {
      month: "long",
      year: "numeric",
    });
    const dayFormatter = new Intl.DateTimeFormat("en-US", { day: "numeric" });

    const startDay = dayFormatter.format(start);
    const endDay = dayFormatter.format(end);
    const monthYear = monthYearFormatter.format(start);
    return `${startDay} to ${endDay} ${monthYear}`;
  }

  const handlePopup = () => {
    setShowPopup(!showPopup);
  };

  //commented by sumanth
  // const handleChangeChildren = (e, i) => {
  //   const value = parseInt(e.target.value, 10);
  //   setChildrenCount((prev) => ({ ...prev, [i]: value }));
  // };

  const handleChangeChildren = (e, i) => {
    const count = parseInt(e.target.value, 10); 
    setChildrenCount(e.target.value);
    localStorage.setItem("ChildrenCount", e.target.value);

    // Set default age as 0 for all selected children
    const defaultAges = Array.from({ length: count }, () => 0);
    const defaultAgesString = Array.from({ length: count }, () => 0).join(',')
    // setChildrenAges(defaultAges);
    localStorage.setItem("ChildrenAgesArray", JSON.stringify(defaultAges));
    localStorage.setItem("ChildrenAges", defaultAgesString);
  };

  // const closePopup = () => {
  //   setShowPopup(false);
  // };

  // var extradata;
  /**
   * date calculation
   */
  useEffect(() => {
    if (datetimevalue && datetimevalue1) {
      const date1 = new Date(datetimevalue);
      const date2 = new Date(datetimevalue1);
      const diffInMs = Math.abs(date2 - date1);
      let moddata = diffInMs / (1000 * 60 * 60 * 24);
      // eslint-disable-next-line
      timedifferences = Math.trunc(Number(moddata));
      setTimediff(timedifferences + 1);
      if (Number.isInteger(moddata)) {
        setDiffDate(moddata);
      } else {
        setDiffDate(Math.trunc(Number(moddata + 1)));
      }
    }
    // eslint-disable-next-line
  }, [checkindate, checkoutdate, checkintime, checkouttime]);

  useEffect(() => {
    /**
     * the sum of amount that is coming from api loop
     */

    roomData?.[0]?.room_amount &&
      roomData?.[0]?.room_amount.map((data) => {
        if (data?.date >= checkindate && data?.date < checkoutdate) {
          actualamount = Number(actualamount) + Number(data?.price);
          countlength = Number(countlength + 1);
          adultcount.map((data1) => {
            if (data1 == 1) {
              total_pay_amount =
                Number(total_pay_amount) +
                Number(data?.price - roomData?.[0]?.single_occupancy_price);
              if (
                Number(data?.price - roomData?.[0]?.single_occupancy_price) >=
                7500
              ) {
                singletax =
                  Number(singletax) +
                  Number(data?.price - roomData?.[0]?.single_occupancy_price) *
                  Number(18 / 100);
              } else {
                singletax =
                  Number(singletax) +
                  Number(data?.price - roomData?.[0]?.single_occupancy_price) *
                  Number(12 / 100);
              }
            } else if (data1 == 2) {
              total_pay_amount = Number(total_pay_amount) + Number(data?.price);
              if (Number(data?.price) >= 7500) {
                singletax =
                  Number(singletax) +
                  Number(Number(data?.price) * Number(18 / 100));
              } else {
                singletax =
                  Number(singletax) +
                  Number(Number(data?.price) * Number(12 / 100));
              }
            } else {
              total_pay_amount =
                Number(total_pay_amount) +
                Number(data?.price) +
                Number(roomData?.[0]?.extra_occupancy);
              if (
                Number(data?.price) + Number(roomData?.[0]?.extra_occupancy) >=
                7500
              ) {
                singletax =
                  Number(singletax) +
                  Number(
                    Number(
                      Number(data?.price) +
                      Number(roomData?.[0]?.extra_occupancy)
                    ) * Number(18 / 100)
                  );
              } else {
                singletax =
                  Number(singletax) +
                  Number(
                    Number(
                      Number(data?.price) +
                      Number(roomData?.[0]?.extra_occupancy)
                    ) * Number(12 / 100)
                  );
              }
            }
          });
        }
        //console.log(singletax);
      });

    //skip day amount calculation
    setdisplaycount(true);
    // set true if singleoccpied  and extraoccpied appears
    var singOccupiedArr = [],
      extrOccupiedArr = [];
    adultcount.map((data1) => {
      adults = Number(adults) + Number(data1);
      if (Number(data1) === 1) {
        singOccupiedArr.push(true);
        setsingleOccupied(singOccupiedArr);
      } else {
        singOccupiedArr.push(false);
        setsingleOccupied(singOccupiedArr);
      }
      if (Number(data1) === 3) {
        extrOccupiedArr.push(true);
        setExtraOccupied(extrOccupiedArr);
      } else {
        extrOccupiedArr.push(false);
        setExtraOccupied(extrOccupiedArr);
      }

      // setdisplaycount(true);
      if (adultcount.length > 0 && data1 == "") {
        setdisplaycount(false);
      } else {
        if (data1 == 1) {
          skipdayamount =
            Number(skipdayamount) +
            Number(roomData?.[0]?.price) -
            Number(roomData?.[0]?.single_occupancy_price);
          if (
            Number(
              roomData?.[0]?.price - roomData?.[0]?.single_occupancy_price
            ) >= 7500
          ) {
            skiptax =
              Number(skiptax) +
              (Number(
                roomData?.[0]?.price - roomData?.[0]?.single_occupancy_price
              ) *
                18) /
              100;
          } else {
            skiptax =
              Number(skiptax) +
              (Number(
                roomData?.[0]?.price - roomData?.[0]?.single_occupancy_price
              ) *
                12) /
              100;
          }
        } else if (data1 == 2) {
          skipdayamount = Number(skipdayamount) + Number(roomData?.[0]?.price);
          if (Number(roomData?.[0]?.price) >= 7500) {
            skiptax =
              Number(skiptax) + (Number(roomData?.[0]?.price) * 18) / 100;
          } else {
            skiptax =
              Number(skiptax) + (Number(roomData?.[0]?.price) * 12) / 100;
          }
        } else {
          skipdayamount =
            Number(skipdayamount) +
            Number(roomData?.[0]?.price) +
            Number(roomData?.[0]?.extra_occupancy);

          if (
            Number(roomData?.[0]?.price) +
            Number(roomData?.[0]?.extra_occupancy) >=
            7500
          ) {
            skiptax =
              Number(skiptax) +
              Number(
                Number(
                  Number(roomData?.[0]?.price) +
                  Number(roomData?.[0]?.extra_occupancy)
                ) * Number(18 / 100)
              );
          } else {
            skiptax =
              Number(skiptax) +
              Number(
                Number(
                  Number(roomData?.[0]?.price) +
                  Number(roomData?.[0]?.extra_occupancy)
                ) * Number(12 / 100)
              );
          }
        }
      }
    });

    extradata =
      Number(total_pay_amount) +
      Number(skipdayamount) * Number(diffDate - countlength);

    // let data = 0;
    // const lastIndex = singleRoomInfo.length - 1;
    // singleRoomInfo.slice(0, lastIndex).forEach((room) => {
    //   data += room.price;
    // });
    // extradata = Number(data);
    // for (let i = 1; i < adultcount.length; i++) {
    //   console.log("mmmmmmmm");
    //   if (adultcount[i] === "2") {
    //     extradata = Number(extradata);
    //   }
    //   if (adultcount[i] === "1") {
    //     extradata = Number(extradata) - Number(singleOccCharge);
    //   }
    //   if (adultcount[i] === "3") {
    //     extradata = Number(extradata) - Number(extraOccCharge);
    //   }
    // }
    //console.log(adultcount[0], "nnnnn");

    // adultcount.forEach((count) => {
    //   console.log(count, "nnn");
    // });

    // extradata = singleRoomInfo.forEach((room) => {
    //   if (room.price) {
    //     extradata += room.price;
    //   }
    // });
    // let data = 0;
    // singleRoomInfo.slice(0, -1).forEach((room) => {
    //   data += room.price;
    // });
    setdatafinalvalue(extradata);
    actualamount =
      Number(actualamount) +
      Number(roomData?.[0]?.price) * Number(diffDate - countlength);
    setactamount(actualamount);
    totTax =
      Number(singletax) + Number(skiptax) * Number(diffDate - countlength);
    setdatafinaltax(totTax);
    setAdult(adults);
  }, [adultcount, checkindate, checkoutdate, displaycount, singleRoomInfo]);

  /**
   * get info
   */
  useEffect(() => {
    // getRoomInfo();
    if (user_id) {
      roomInfo();
    }
    getMyDetails();
    setStartEndDate(
      formatDateRange(
        localStorage.getItem("datetime1"),
        localStorage.getItem("datetime2")
      )
    );
    setStartEndDateRange(
      formatDateRangessss(
        localStorage.getItem("datetime1"),
        localStorage.getItem("datetime2")
      )
    );

    if (localStorage.getItem("id") !== "null") {
      let updatedLists;
      let elements = [];
      updatedLists = localStorage.getItem("id");
      if (updatedLists) {
        let lines = updatedLists.split(",");

        for (let i = 0; i < lines.length; i++) {
          elements.push(lines[i]);
        }

        if (elements[0] !== "") {
          setServiceId(elements);
        } else {
          setServiceId([]);
        }
      }
    }

    if (localStorage.getItem("service") !== "null") {
      let updatedLists;
      let elements = [];
      updatedLists = localStorage.getItem("service");
      if (updatedLists) {
        let lines = updatedLists.split(",");

        for (let i = 0; i < lines.length; i++) {
          elements.push(lines[i]);
        }

        if (elements[0] !== "") {
          setUpService(elements);
        } else {
          setUpService([]);
        }
      }
    }

    if (localStorage.getItem("service1") !== "null") {
      let updatedLists;
      let elements = [];
      updatedLists = localStorage.getItem("service1");
      if (updatedLists) {
        let lines = updatedLists.split(",");

        for (let i = 0; i < lines.length; i++) {
          elements.push(lines[i]);
        }

        if (elements[0] !== "") {
          setUpService1(elements);
        } else {
          setUpService1([]);
        }
      }
    }

    if (localStorage.getItem("amountdata") !== "null") {
      let updatedLists;
      let elements = [];
      updatedLists = localStorage.getItem("amountdata");
      if (updatedLists) {
        let lines = updatedLists.split(",");

        for (var i = 0; i < lines.length; i++) {
          elements.push(lines[i]);
        }

        if (elements[0] !== "") {
          setAmountData(elements);
        } else {
          setAmountData([]);
        }
      }
    }
    if (localStorage.getItem("amountdata1") !== "null") {
      let updatedLists;
      let elements = [];
      updatedLists = localStorage.getItem("amountdata1");
      if (updatedLists) {
        let lines = updatedLists.split(",");

        for (let i = 0; i < lines.length; i++) {
          elements.push(lines[i]);
        }

        if (elements[0] !== "") {
          setAmountData1(elements);
        } else {
          setAmountData1([]);
        }
      }
    }
  }, []);

  const formatDateRange = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const options = { month: "long", day: "2-digit", year: "numeric" };
    const startFormatted = new Intl.DateTimeFormat("en-US", options).format(
      start
    );
    const endFormatted = new Intl.DateTimeFormat("en-US", options).format(end);
    const startFinal = startFormatted.replace(",", " /");
    const endFinal = endFormatted.replace(",", " /");
    return `${startFinal} - ${endFinal}`;
  };

  const getMyDetails = () => {
    setLoader("loading");
    MyAccountService.getMyAccountDetails(user_id)
      .then((res) => {
        if (res?.data?.status?.code === 0) {
          setMobile_no(res?.data?.data?.[0]?.phone);
          setEmail(res?.data?.data?.[0]?.email);
          setFullName(res?.data?.data?.[0]?.name);
          setLoader("isfull");
        }
      })
      .catch((error) => {
        console.log("Errorreg", error);
      });
  };

  useEffect(() => {
    convert(localStorage.getItem("datetime1"));
    convertCheckout(localStorage.getItem("datetime2"));
    localStorage.setItem("datetime1", datetimevalue);
    localStorage.setItem("datetime2", datetimevalue1);
    // eslint-disable-next-line
  }, [checkindate, checkoutdate, checkintime, checkouttime]);

  useEffect(() => {
    var amountDataCount = 0;
    var amountDataCount1 = 0;
    var tot_count = Number(adult) + Number(children);
    amountData.map(
      (data) =>
      (amountDataCount =
        Number(amountDataCount) +
        Number(data) * Number(diffDate === 0 ? 1 : diffDate))
    );
    amountData1.map(
      (data) => (amountDataCount1 = Number(amountDataCount1) + Number(data))
    );
    amountDataCount =
      Number(amountDataCount) * Number(tot_count <= 0 ? 1 : tot_count);
    setAddAmount(amountDataCount);
    setAddAmount1(amountDataCount1);

    setExtra(Number(addAmount) + Number(addAmount1));
    localStorage.setItem("adult", Number(adult));
    localStorage.setItem("children", Number(children));
    localStorage.setItem("rooms", Number(rooms));

    if (adult === 1 || rooms * roomData?.[0]?.no_of_occupancy - adult === 1) {
      extradata = extradata - roomData?.[0]?.single_occupancy_price;
    }

    // eslint-disable-next-line
  }, [adult, rooms, children, amountData, amountData1, addAmount, addAmount1]);

  useEffect(() => {
    service &&
      service.map((data) => {
        servId &&
          servId.map((data1) => {
            if (data?._id === data1) {
              if (data?.people_choice === true) {
                let servicetotal =
                  data?.price *
                  (children + adult > 0 ? children + adult : 1) *
                  (diffDate === 0 ? 1 : diffDate);

                update.push({ id: data1, price: servicetotal });
              } else {
                let servicetotal = commaValidation(
                  Number(data?.price * (diffDate === 0 ? 1 : diffDate))
                );

                update.push({ id: data1, price: servicetotal });
              }
            }
          });
      });
    setTotalService(update);
  }, [adult, rooms, children, service, diffDate, servId]);

  /**
   * get room info
   */
  const getRoomInfo = () => {
    // console.log(datetimevalue, datetimevalue1, "datetimevaluedatetimevalue");
    setLoader("loading");
    StandardService.getRoomInfo(location?.state?.id, checkindate, checkoutdate)
      .then((data) => {
        setSingleOccCharge(
          data?.data?.data?.[0]?.no_of_occupancy *
          data?.data?.data?.[0]?.single_occupancy_price
        );
        setSingleOccCharge(
          data?.data?.data?.[0]?.no_of_occupancy *
          data?.data?.data?.[0]?.extra_occupancy
        );
        if (data?.data?.status?.code === 0) {
          setRoomData(data?.data?.data);
          setLoader("isfull");
        }
      })
      .catch((error) => {
        console.log("Errorreg", error);
      });
  };

  /**
   * get room info
   */
  const roomInfo = () => {
    setLoader("loading");
    StandardService.online()
      .then((res) => {
        setService(res?.data?.data?.service);
        setLoader("isfull");
      })
      .catch((error) => {
        console.log("Errorreg", error);
      });
  };

  useEffect(() => {
    if (checkindate !== undefined && checkoutdate !== undefined) {
      getSingleRoomInfo();
      getRoomInfo();
    }
  }, [checkindate, checkoutdate]);

  //get single room info
  const getSingleRoomInfo = () => {
    setLoader("loading");
    StandardService.getSingleRoomInfo(
      location?.state?.id,
      checkindate,
      checkoutdate
    )
      .then((data) => {
        if (data?.data?.status?.code === 0) {
          setSingleRoomInfo(data?.data?.data?.rooms[0]?.room_amount);
          setLoader("isfull");
        }
      })
      .catch((error) => {
        console.log("Errorreg", error);
      });
  };

  const [childrenAges, setChildrenAges] = useState(
    Array(childrenCount).fill("")
  );

  const handleChildAgeChange = (index, event) => {
    const newAges = [...childrenAges];
    newAges[index] = parseInt(event.target.value, 10);
    setChildrenAges(newAges);
    localStorage.setItem("ChildrenAges", newAges);
    localStorage.setItem("ChildrenAgesArray", JSON.stringify(newAges));
    console.log("Updated Children Ages:", newAges);
  };


  const handleChangeRequest = (event) => {
    setRequest(event.target.value);
    console.log(event.target.value); // Logs the input in real-time
  };

  const sendSpecialRequest = async () => {
    try {
      const response = await BookingDetailsService.specialRequestAdd(request)
    } catch (error) {
      console.log(error)
    }
    // BookingDetailsService.specialRequestAdd(request).then((res) => {
    //   if (res?.data?.status?.code === 0) {
    //     // dispatch(alertActions.success(res?.data?.status?.message));
    //     // localStorage.setItem("cartNotLoggedIn", "");
    //   } else {
    //     // dispatch(alertActions.error(res?.data?.status?.message));
    //     // window.location.reload();
    //   }
    // });
  }

  /**
   * continue to back
   * api call only after entering all correct details
   * @param {*} e
   */
  const continuToBook = (e) => {
    sendSpecialRequest()
    e.preventDefault();

    if (!rooms) {
      dispatch(alertActions.error(t("Enter_Valid_Rooms_Count")));
    } else if (!datetimevalue || !datetimevalue1) {
      dispatch(alertActions.error(t("Enter_Both_Check-In_and_Check-Out_Time")));
    } else if (new Date(datetimevalue) >= new Date(datetimevalue1)) {
      dispatch(alertActions.error(t("Checkin_and_Checkout_Date_is_Invalid")));
    } else if (!displaycount) {
      dispatch(
        alertActions.error(t("Please select adult count for all rooms"))
      );
    } else {
      var costData = Number(
        roomData?.[0]?.price * rooms * (diffDate > 0 ? diffDate : 1) +
        (adult + children > 4
          ? roomData?.[0]?.extra_occupancy * (adult + children - 4)
          : 0)
      );
      console.log(roomData, "roomDataroomData");

      var bookingDetails = [
        {
          adults: Number(adultcount),
          infantAge: childrenCount[0] > 0 ? childrenAges : [],
          // infantAge: [2, 10, 12],
        },
      ];
      if (checkindate && checkintime && checkoutdate && checkouttime) {
        setLoader("loading");
        StandardService.bookingInCart(
          checkindate,
          "2:00 PM",
          checkoutdate,
          "12:00 PM",
          adultcount.map(Number),
          children,
          location?.state?.id,
          adultcount.length,
          Number(roomData?.[0]?.price ? roomData?.[0]?.price : 0),
          extra,
          totalPayableAmount,
          Math.round(diffDate).toFixed(0),
          name,
          phone,
          timediff,
          diffDate,
          servId,
          totservice,
          roomData?.[0]?.extra_occupancy,
          roomData?.[0]?.single_occupancy_price,
          datafinaltax,
          roomData?.[0]?.no_of_occupancy,
          singleOccupied,
          extraOccupied,
          totalGstCharge,
          bookingDetails,
          roomData?.[0]?.no_of_infants ? roomData?.[0]?.no_of_infants : 0
        )
          .then((res) => {
            if (res?.data?.status?.code === 0) {
              dataPath = res?.data?.data?.[0]?._id;
              const ids = res?.data?.data?.map((item) => item._id) || [];
              setBookingId(ids);
              navigate(`/bookingDetails?id=${dataPath}`, {
                state: {
                  data: res?.data?.data,
                  date: diffDate,
                  timediff: timediff,
                  diff: diffDate,
                  adultcount: adultcount,
                  datafinalvalue: datafinalvalue,
                  actualamt: totalPayableAmount,
                  taxamt: totalGstCharge,
                  roomchargeamt: totalRoomCharge,
                },
              });
              setLoader("isfull");
            } else {
              dispatch(alertActions.error(res?.data?.status?.message));
              window.location.reload();
              setLoader("isfull");
            }
          })
          .catch((err) => console.log(err));
      }
    }
  };

  /**
   * model
   */
  const closeShipping = () => {
    document.body.classList.remove("modal-open");
    setShowShipping(false);
  };
  /**
   * model display
   */
  const openShipping = () => {
    document.body.classList.add("modal-open");
    setShowShipping(true);
  };
  /**
   * chenge image on image click
   * @param {*} data
   */
  const selectPath = (data) => {
    setPathimg(data);
  };

  /**
   * get time and date
   * @param {*} str
   */
  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2),
      hours = 12,
      minutes = ("0" + date.getMinutes()).slice(-2);

    setCheckindate([date.getFullYear(), mnth, day].join("-"));
    setCheckintime([hours, minutes].join(":"));
  }

  /**
   * convert check out
   * @param {*} str
   */
  function convertCheckout(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2),
      hours = 23,
      minutes = ("0" + date.getMinutes()).slice(-2);

    setCheckoutdate([date.getFullYear(), mnth, day].join("-"));
    setCheckouttime([hours, minutes].join(":"));
  }
  /**
   * set localstorage value
   * @param {*} e
   */
  const onChangeValue = (e) => {
    localStorage.setItem("datetime1", e);
    setdatetimevalue(
      localStorage.getItem("datetime1")
        ? localStorage
          .getItem("datetime1")
          .replace(
            "00:00:00 GMT+0530" ||
            "01:00:00 GMT+0530" ||
            "02:00:00 GMT+0530" ||
            "03:00:00 GMT+0530" ||
            "04:00:00 GMT+0530" ||
            "05:00:00 GMT+0530" ||
            "06:00:00 GMT+0530" ||
            "07:00:00 GMT+0530" ||
            "08:00:00 GMT+0530" ||
            "09:00:00 GMT+0530" ||
            "10:00:00 GMT+0530" ||
            "11:00:00 GMT+0530" ||
            "12:00:00 GMT+0530" ||
            "13:00:00 GMT+0530" ||
            "14:00:00 GMT+0530" ||
            "15:00:00 GMT+0530" ||
            "16:00:00 GMT+0530" ||
            "17:00:00 GMT+0530" ||
            "18:00:00 GMT+0530" ||
            "19:00:00 GMT+0530" ||
            "20:00:00 GMT+0530" ||
            "21:00:00 GMT+0530" ||
            "22:00:00 GMT+0530" ||
            "23:00:00 GMT+0530" ||
            "24:00:00 GMT+0530",
            "12:00:00 GMT+0530"
          )
        : ""
    );
    convert(e);
  };
  /**
   * set localstorage value for checkout date
   * @param {*} e
   */
  const onChangeValue1 = (e) => {
    localStorage.setItem("datetime2", e);
    setdatetimevalue1(
      localStorage.getItem("datetime2")
        ? localStorage
          .getItem("datetime2")
          .replace(
            "00:00:00 GMT+0530" ||
            "01:00:00 GMT+0530" ||
            "02:00:00 GMT+0530" ||
            "03:00:00 GMT+0530" ||
            "04:00:00 GMT+0530" ||
            "05:00:00 GMT+0530" ||
            "06:00:00 GMT+0530" ||
            "07:00:00 GMT+0530" ||
            "08:00:00 GMT+0530" ||
            "09:00:00 GMT+0530" ||
            "10:00:00 GMT+0530" ||
            "11:00:00 GMT+0530" ||
            "12:00:00 GMT+0530" ||
            "13:00:00 GMT+0530" ||
            "14:00:00 GMT+0530" ||
            "15:00:00 GMT+0530" ||
            "16:00:00 GMT+0530" ||
            "17:00:00 GMT+0530" ||
            "18:00:00 GMT+0530" ||
            "19:00:00 GMT+0530" ||
            "20:00:00 GMT+0530" ||
            "21:00:00 GMT+0530" ||
            "22:00:00 GMT+0530" ||
            "23:00:00 GMT+0530" ||
            "24:00:00 GMT+0530",
            "11:00:00 GMT+0530"
          )
        : ""
    );
    convertCheckout(e);
  };

  /**
   * check price
   * @param {*} val
   * @param {*} members
   * @param {*} e
   *
   * checkprice functionality for extra service
   */

  const checkPrice = (service, val, members, e, id) => {
    servicearray = [...servId];
    updatedList = [...amountData];
    updatedList1 = [...amountData1];

    updatedService = [...upService];
    updatedService1 = [...upService1];
    if (e.target.checked) {
      servicearray = [...servId, id];
      if (members) {
        updatedList = [...amountData, val];
        updatedService = [...upService, service];
      } else {
        updatedList1 = [...amountData1, val];
        updatedService1 = [...upService1, service];
      }
    } else {
      servicearray.splice(servId.indexOf(id), 1);
      if (members) {
        updatedList.splice(amountData.indexOf(val), 1);
        updatedService.splice(upService.indexOf(service), 1);
      } else {
        updatedList1.splice(amountData1.indexOf(val), 1);
        updatedService1.splice(upService1.indexOf(service), 1);
      }
    }
    setServiceId(servicearray);
    setAmountData(updatedList);
    setAmountData1(updatedList1);

    setUpService(updatedService);
    setUpService1(updatedService1);
    localStorage.setItem("amountdata", [updatedList]);
    localStorage.setItem("id", [servicearray]);
    localStorage.setItem("amountdata1", [updatedList1]);
    // console.log(servicearray)
    localStorage.setItem("service", [updatedService]);
    localStorage.setItem("service1", [updatedService1]);
  };

  /**
   * handle checkbox
   * @param {*} e
   */

  const isInCategory = (title) => {
    return upService.includes(title) || upService1.includes(title);
  };
  /**
   * initially taking one array and pushing all dropdown price in array
   */
  const handleAdd = () => {
    if (
      !checkindate ||
      checkindate == "NaN-aN-aN" ||
      !checkoutdate ||
      checkoutdate == "NaN-aN-aN"
    ) {
      dispatch(
        alertActions.error("Please select valid checkin and checkout date")
      );
    } else {
      setRoomAdded("YES");
      //console.log("Add Room Entered");
      const newdata = [...adultcount, []];
      setAdultcount(newdata);
    }
  };

  const addToCart = () => {
    if (!rooms) {
      dispatch(alertActions.error(t("Enter_Valid_Rooms_Count")));
    } else if (!datetimevalue || !datetimevalue1) {
      dispatch(alertActions.error(t("Enter_Both_Check-In_and_Check-Out_Time")));
    } else if (new Date(datetimevalue) >= new Date(datetimevalue1)) {
      dispatch(alertActions.error(t("Checkin_and_Checkout_Date_is_Invalid")));
    } else if (!displaycount) {
      dispatch(
        alertActions.error(t("Please select adult count for all rooms"))
      );
    } else {
      if (checkindate && checkintime && checkoutdate && checkouttime) {
        console.log(adultcount, "adultcount");
        // const numericAdultCount = adultcount.map(Number);
        setLoader("loading");
        StandardService.bookingInCart(
          checkindate,
          "2:00 PM",
          checkoutdate,
          "12:00 PM",
          adultcount.map(Number),
          children,
          location?.state?.id,
          adultcount.length,
          Number(roomData?.[0]?.price ? roomData?.[0]?.price : 0),
          extra,
          totalPayableAmount,
          Math.round(diffDate).toFixed(0),
          name,
          phone,
          timediff,
          diffDate,
          servId,
          totservice,
          roomData?.[0]?.extra_occupancy,
          roomData?.[0]?.single_occupancy_price,
          datafinaltax,
          roomData?.[0]?.no_of_occupancy,
          singleOccupied,
          extraOccupied,
          totalGstCharge,
          roomData?.[0]?.no_of_infants ? roomData[0].no_of_infants : 0
        )
          .then((res) => {
            if (res?.data?.status?.code === 0) {
              dataPath = res?.data?.data?.[0]?._id;
              const ids = res?.data?.data?.map((item) => item._id) || [];

              console.log(ids, "ids");
              setBookingId(ids);
              if (user_id) {
                // console.log(ids);
                StandardService.addToCart(user_id, ids)
                  .then((res) => {
                    if (res?.data?.status?.code === 0) {
                      dispatch(
                        alertActions.success(res?.data?.status?.message)
                      );
                      navigate("/");
                      setLoader("isfull");
                    } else {
                      dispatch(alertActions.error(res?.data?.status?.message));
                      window.location.reload();
                      setLoader("isfull");
                    }
                  })
                  .catch((err) => console.log(err));
                // location?.state?.data.map((data) => mydata.push(data?._id));
                // console.log(mydata, "mydata");
              } else {
                localStorage.setItem("cartNotLoggedIn", ids);

                navigate("/");
                // dispatch(alertActions.error(t("Please login to your account")));
                // navigate("/Login");
              }
            } else {
              dispatch(alertActions.error(res?.data?.status?.message));
              window.location.reload();
              setLoader("isfull");
            }
          })
          .catch((err) => console.log(err));
      }
    }
  };

  const convertDate = (datetimevalue) => {
    const dateObject = new Date(datetimevalue);
    const formattedDate = dateObject.toISOString().split("T")[0];
    return formattedDate;
  };

  useEffect(() => {
    setFormattedArrivalDate(convertDate(datetimevalue));
    setFormattedDepartureDate(convertDate(datetimevalue1));
  }, []);
  /**
   * change the particular index value
   * @param {*} value
   * @param {*} i
   */
  const handleChange = (value, i) => {
    const inputdata = [...adultcount];
    inputdata[i] = value.target.value;
    setAdultcount(inputdata);
    localStorage.setItem("AdultCount", value.target.value);
  };

  useEffect(() => {
    if (AdultCountLoc) {
      setRoomAdded("YES");
      setAdultcount([...AdultCountLoc]);
    }
    if (ChildrenCountLoc) {
      setChildrenCount(ChildrenCountLoc);
    }
    if (ChildrenAgesLoc) {
      const parsedAges = ChildrenAgesLoc.split(",").map(Number);
      setChildrenAges(parsedAges);
    }
    setInitialLoad(false);
  }, [AdultCountLoc, ChildrenCountLoc, ChildrenAgesLoc]);

  useEffect(() => {
    console.log(adultcount, "ADULTCOUNT");
    const parsedAges = ChildrenAgesLoc
      ? ChildrenAgesLoc.split(",").map(Number)
      : [];
    const adjustedAdultCount = initialLoad
      ? (Number(AdultCountLoc) || 0) +
      parsedAges.filter((age) => age > 7).length
      : (Number(adultcount[0]) || 0) +
      childrenAges.filter((age) => age > 7).length;

    const convertedResponse = adultcount.map((adult_count, index) => ({
      number: index + 1,
      adult_count: adjustedAdultCount,
    }));

    localStorage.setItem("adult_count", JSON.stringify(convertedResponse));

    BookingDetailsService.amount_calculation(
      formattedArrivalDate,
      formattedDepartureDate,
      room_id,
      convertedResponse
    )
      .then((res) => {
        if (res?.data?.status?.code === 0) {
          res?.data?.data?.slice(0, -1).forEach((item) => {
            item?.detail?.forEach((detailItem) => {
              const roomCharge = detailItem?.roomCharge;
              if (typeof roomCharge === "number") {
                calculatedTotal += roomCharge;
              }
            });
          });
          setTableCalucation(res?.data?.data);
          console.log(res?.data?.data);
          setTotalRoomCharge(calculatedTotal);
          res?.data?.data?.slice(0, -1).forEach((item) => {
            item?.detail?.forEach((detailItem) => {
              const gst = detailItem?.gst;
              if (typeof gst === "number") {
                calculatedGstCharge += gst;
              }
            });
          });
          setTotalGstCharge(calculatedGstCharge);
          setTotalPayableAmount(calculatedTotal + calculatedGstCharge);
        } else {
          console.log("ERROR MESSAGE", res.data.status.message);
        }
      })
      .catch((error) => {
        console.log("Errorreg", error);
      });
  }, [adultcount, ChildrenAgesLoc, childrenAges]);
  /**
   * remove one textbox at a time
   * @param {*} i
   */
  const handleDelete = (i) => {
    const deleteval = [...adultcount];
    deleteval.splice(i, 1);
    setAdultcount(deleteval);
  };

  return {
    checkindate,
    checkoutdate,
    adult,
    children,
    rooms,
    showShipping,
    roomData,
    pathimg,
    datetimevalue,
    datetimevalue1,
    service,
    extra,
    diffDate,
    loader,
    extradata,
    taxdata,
    adultcount,
    datafinalvalue,
    datafinaltax,
    singleRoomInfo,
    roomAmount,
    totalRoomCharge,
    totalGstCharge,
    totalPayableAmount,
    fullName,
    mobile_no,
    email,
    startEndDate,
    startEndDateRange,
    tableCalculation,
    childrenCount,
    handleDelete,
    handleChange,
    handleAdd,
    addToCart,
    isInCategory,
    continuToBook,
    onChangeValue1,
    closeShipping,
    openShipping,
    selectPath,
    convert,
    onChangeValue,
    checkPrice,
    handlePopup,
    handleChangeChildren,
    handleChildAgeChange,
    // closePopup,
    roomAdded,
    user_id,
    showPopup,
    childrenAges,
    request,
    handleChangeRequest,
    sendSpecialRequest,
  };
};
export default useStandard;
